import React, { useState } from "react";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import emailjs from "@emailjs/browser";
import { BsGithub, BsLinkedin } from "react-icons/bs";
import { SiCodechef, SiLeetcode } from "react-icons/si";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [formStarted, setFormStarted] = useState(false);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    if (!formStarted) {
      setFormStarted(true);
    }
  };

  const handleSubmit = async () => {
    setErrors("");
    setLoading("Validating email...");
    const emailCheck = new RegExp(
      "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\\.[a-zA-Z0-9-]+)*$"
    );

    if (!email || !message || !username) {
      setErrors("Please fill all the fields");
      setLoading(false);
      return;
    }

    if (!emailCheck.test(email)) {
      setErrors("Please enter a valid email");
      setLoading(false);
      return;
    }

    const contact = {
      _type: "contact",
      name: formData.username,
      email: formData.email,
      message: formData.message,
    };
    setLoading("Sending message...");
    client.create(contact).catch((err) => {
      setErrors(err);
    });

    emailjs
      .send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        formData,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      )
      .then(() => {
        setIsFormSubmitted(true);
      })
      .catch((err) => {
        setErrors(err);
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="z-10 flex flex-col items-center">
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer-cards">
        <div className="app__footer-card ">
          <img src={images.email} alt="email" />
          <a href="mailto:lovishtater@gmail.com" className="p-text">
            lovishtater@gmail.com
          </a>
        </div>
      </div>
      <div className="app__footer-cards" style={{ margin: " 0 0 1rem 0" }}>
        <a href="https://www.github.com/lovishtater" className="p-text">
          <div className="small-card">
            <BsGithub className="app__footer-icon" />
            Github
          </div>
        </a>
        <a href="https://www.linkedin.com/in/lovishtater08" className="p-text">
          <div className="small-card">
            <BsLinkedin className="app__footer-icon" />
            LinkedIn
          </div>
        </a>
        <a href="https://www.leetcode.com/lovishtater" className="p-text">
          <div className="small-card" style={{ minWidth: "none" }}>
            <SiLeetcode className="app__footer-icon" />
            Leetcode
          </div>
        </a>
        <a
          href="https://www.codechef.com/users/lovishtater"
          className="p-text"
          target="_blank"
          rel="noreferrer"
        >
          <div className="small-card" style={{ minWidth: "none" }}>
            <SiCodechef className="app__footer-icon" />
            Codechef
          </div>
        </a>
      </div>

      {!isFormSubmitted ? (
        <div className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="username"
              value={username}
              onChange={handleChangeInput}
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
            />
          </div>
          {errors && <p className="error-text">{errors}</p>}
          <button type="button" className="p-text" onClick={handleSubmit}>
            {!loading ? "Send Message" : loading}
          </button>
        </div>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )}
    </div>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__primarybg"
);
